import React__default, { useRef, useEffect } from 'react';
import Box from './Box.js';
import Typography from './Typography.js';
import LoadingIndicator from './LoadingIndicator.js';
import IconTooltip from './IconTooltip.js';
import createTimePickerOptions from './createTimePickerOptions.js';
import 'styled-components';
import './useTheme.js';
import './_commonjsHelpers-357b3b4e.js';
import './core.esm-901288dd.js';
import './inheritsLoose-6f2ea841.js';
import './Icon.js';
import './global-2e5d81b9.js';
import './styled-722a6242.js';
import './index-a67b9a05.js';
import './getThemeProps-582952b7.js';
import './useTheme-3df06c17.js';
import './useThemeProps-624634df.js';
import './generateUtilityClasses-06dec860.js';
import './Popper-538498ba.js';
import './useSlotProps-263f7ba4.js';
import './Portal-4e916b93.js';
import 'react-dom';
import './useEnhancedEffect-22d6b63a.js';
import './exactProp-86bc0113.js';
import './refType-6972e729.js';
import './useId-748eec35.js';
import './TransitionGroupContext-42c2fd98.js';
import './useIsFocusVisible-b9c63ec9.js';
import './utils-c09c4ec9.js';
import './objectWithoutPropertiesLoose-6737dabb.js';
import './index-5fd269e1.js';
import './index-48edd52c.js';

const TimePickerItem = ({
  label,
  onPress,
  selected,
  testID
}) => {
  const ref = useRef(null);
  useEffect(() => {
    if (selected) {
      if (ref.current && ref.current.scrollIntoView) {
        ref.current.scrollIntoView({
          block: 'center',
          inline: 'nearest'
        });
      }
    }
  }, [ref.current, selected]);
  return /*#__PURE__*/React__default.createElement(Box, {
    cursor: "pointer",
    key: label,
    marginBottom: "base",
    onPress: onPress,
    ref: ref,
    testID: testID
  }, /*#__PURE__*/React__default.createElement(Typography, {
    center: true,
    color: selected ? 'tertiary' : 'quaternary',
    variant: "label-1"
  }, label));
};

const TimePicker = ({
  loading,
  loadingTestID,
  onSelect,
  options,
  renderEmptyState,
  selectedItemTestID,
  selectedTime,
  testID,
  titleText,
  tooltip,
  tooltipTestID
}) => {
  const handleSelectItem = nextOption => {
    return () => {
      onSelect(nextOption.value);
    };
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    testID: testID,
    width: "100%",
    textAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    marginBottom: "base",
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    alignContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    center: true,
    color: "primary",
    variant: "headline-3"
  }, titleText), tooltip && /*#__PURE__*/React__default.createElement(Box, {
    marginLeft: "tiny",
    display: "flex",
    justifyContent: "center",
    height: "15px"
  }, /*#__PURE__*/React__default.createElement(IconTooltip, {
    centerText: true,
    title: tooltip,
    name: "16-info",
    testID: tooltipTestID
  }))), renderEmptyState ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderEmptyState()) : /*#__PURE__*/React__default.createElement("div", null, loading ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: 150
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    marginTop: "xxxxLarge",
    testID: loadingTestID
  }, /*#__PURE__*/React__default.createElement(LoadingIndicator, null))) : /*#__PURE__*/React__default.createElement(Box, {
    overflowY: "auto",
    maxHeight: "265px"
  }, options.map(option => {
    const selected = option.value.getTime() === (selectedTime === null || selectedTime === void 0 ? void 0 : selectedTime.getTime());
    return /*#__PURE__*/React__default.createElement(TimePickerItem, {
      key: option.label,
      label: option.label,
      onPress: handleSelectItem(option),
      selected: selected,
      testID: selected ? selectedItemTestID : undefined
    });
  }))));
};

const businessHoursOptions = createTimePickerOptions(9, 22);
createTimePickerOptions(9, 12);

export { businessHoursOptions, TimePicker as default };
//# sourceMappingURL=TimePicker.js.map
